// extracted by mini-css-extract-plugin
export var actionButton = "_7g-1";
export var actionButtons = "_7g-2";
export var actions = "_7g-0";
export var aiUnread = "_7g-10";
export var alignCenter = "_7g-h";
export var backWrapper = "_7g-3";
export var cellContainer = "_7g-4";
export var checkboxContainer = "_7g-5";
export var contentContainer = "_7g-6";
export var contentHeader = "_7g-8";
export var conversationsTableWrapper = "_7g-s";
export var draftReplyBadgeContainer = "_7g-m";
export var dropdownItem = "_7g-b";
export var dropdownItemsContainer = "_7g-a";
export var dropdownTitle = "_7g-c";
export var errorIcon = "_7g-7";
export var filter = "_7g-d";
export var gray = "_7g-i";
export var headerActionButtons = "_7g-e";
export var headerCheckboxContainer = "_7g-f";
export var icon = "_7g-j";
export var menuContainer = "_7g-k";
export var noMoreTicketsIcon = "_7g-12";
export var noMoreTicketsSubText = "_7g-13";
export var oneLine = "_7g-l";
export var optionsButton = "_7g-n";
export var plus = "_7g-o";
export var portalButtonsWrapper = "_7g-g";
export var red = "_7g-p";
export var scrolledTop = "_7g-9";
export var search = "_7g-q";
export var selectedConversationsCount = "_7g-r";
export var spinner = "_7g-t";
export var strong = "_7g-u";
export var summaryCell = "_7g-v";
export var tableContainer = "_7g-11";
export var tagContainer = "_7g-w";
export var threeDots = "_7g-x";
export var twoLines = "_7g-y";
export var unread = "_7g-z";